import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Set } from 'immutable'
import classNames from 'classnames'
import { Image } from '@deal/components'
import { Selectable, SelectableProps } from '#src/components/Path/Selectable'
import SuccessCheck from '../../success-check.svg'
import styles from './styles.css'

export default class OverlayImageSelectable extends Component<SelectableProps> {
  // TODO @fguerra change this to the new context api: https://reactjs.org/docs/legacy-context.html
  public static contextTypes = {
    handleChange: PropTypes.func,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    noCollapse: PropTypes.bool,
    // @ts-ignore: this needs to be replaced with the new context api:
    // https://reactjs.org/docs/legacy-context.html
    values: PropTypes.instanceOf(Set)
  }

  public render() {
    const { id, value, className, headline, body, image, isSingleSelect, ...rest } = this.props
    const { values, name } = this.context
    const isSelected = values && values.has(value)

    const buttonClasses = classNames(className, {
      [styles.common]: true,
      [styles.selected]: isSelected
    })

    const cardContentClasses = classNames({
      [styles.cardContent]: true,
      [styles.noImageContent]: image === undefined
    })

    const selectableId = `${name}-${value}`.toLowerCase()

    return (
      <Selectable
        className={buttonClasses}
        id={selectableId}
        testId={selectableId}
        value={value}
        multiple
        checked={isSelected}
        handleChange={() => this.context.handleChange(value)}
        {...rest}
      >
        {image !== undefined && (
          <Image
            src={image}
            imgixParams={{ fit: 'clip' }}
            className={styles.cardImage}
            width={350}
          />
        )}
        {isSelected && !isSingleSelect && <SuccessCheck className={styles.successCheck} />}

        <div className={cardContentClasses}>
          <div className={styles.descriptionWrapper}>
            {headline && <span className={styles.headline}>{headline}</span>}
          </div>
        </div>
      </Selectable>
    )
  }
}
